(function ($) {
  const app = {
    windowHeight: $(window).height(),
    windowWidth: $(window).width(),
    isMobile: false,
    isTouch: false,
    resizeTimeoutID: null,
    $body: $("body"),
    culture: "en",
    isIe: false,
    responsiveBreakpointValue: "(max-width: 1200px)",
    responsiveBreakpointBoolean: false,
    hamburgerBoolean: false,
    hamburgerBoolean2: false,
    successSwiper: false,
    tabSwiper: null,
    disableAnimation: false,
    lifestyleSwiper: null,
    markersArray: [],
    //	gallerySlider: '',
    detectDevice() {
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        ) {
          app.isMobile = true;
        }
      })(navigator.userAgent || navigator.vendor || window.opera);
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        app.isTouch = true;
        app.$body.addClass("touch");
      } else {
        app.$body.addClass("no-touch");
      }
    },
    detectCulture() {
      if ($("body").hasClass("ar")) {
        app.culture = "ar";
      }
    },
    windowResize() {
      app.windowHeight = $(window).height();
      app.windowWidth = $(window).width();
      $(".spotlight__slide.swiper-slide").height(
        $(".swiper-spacer").outerHeight()
      );
    },
    resizeListner() {
      if (!app.isMobile) {
        $(window).resize(() => {
          clearTimeout(app.resizeTimeoutID);
          app.resizeTimeoutID = setTimeout(app.windowResize, 500);
        });
      } else {
        window.addEventListener("orientationchange", () => {
          app.windowResize();
        });
      }
    },
    addEventListner() {

     
        
    
      $('.custom-file-field input').change(function() {
        $(this).parent('.custom-file-field').find('span').text($(this)[0].files[0].name);
      });


      $(".header__menu").click(function () {
        $(".menu--header").addClass("active");
        $("body").addClass("menu-open");
      });
      $(".menu__close").click(function () {
        $(".menu--header").removeClass("active");
        $("body").removeClass("menu-open");
      });
      $(".floating-tools__btn").click(function () {
        $(this).toggleClass("active");
        $(".floating-tools .tools").toggleClass("active");
      });

      $(".bod__item").click(function () {
        $(this).find(".bod__overlay").css("display", "grid");
        $("body").addClass("overflow-hidden");
      });
      $(".bod__overlay svg").click(function (e) {
        e.stopPropagation();

        $(".bod__overlay").hide();
        $("body").removeClass("overflow-hidden");
      });

      // $('.form-btn').click(function (e) {
      // 	e.preventDefault()
      // 	$('.inquire__calculator').removeClass('d-none')
      // 	$('.inquire__form').addClass('d-none')
      // })

      if (app.windowWidth <= 992) {
        $(".menu__main a").click(function (e) {
          // alert('asd')
          e.preventDefault();
        });
      } else {
        $("footer").css("min-height", $("footer").outerHeight() + 50);
        $(".menu__menu").each(function () {
          if ($(this).find(".mobile-only").length != 0) {
            $(this).hide();
          }
        });
      }

      setTimeout(function () {
        $("footer .menu__right").addClass("d-none");
        $("footer .menu__right")
          .eq($("footer .menu__main a.active").index())
          .removeClass("d-none");
        $("nav .menu__right").addClass("d-none");
        $("nav .menu__right")
          .eq($("nav .menu__main a.active").index())
          .removeClass("d-none");
      });

      $("footer .menu__main a").hover(
        function () {
          $("footer .menu__main a").removeClass("hover");

          $(this).addClass("hover");
          $("footer .menu__right").addClass("d-none");
          $("footer .menu__right").eq($(this).index()).removeClass("d-none");
          console.log("footer hover");
        },
        function () {}
      );
      $("nav .menu__main a").hover(
        function () {
          $("nav .menu__main a").removeClass("hover");
          $(this).addClass("hover");
          $("nav .menu__right").addClass("d-none");
          $("nav .menu__right").eq($(this).index()).removeClass("d-none");
        },
        function () {}
      );

      $("footer .row")
        .eq(1)
        .hover(
          function () {},
          function () {
            console.log("hover out from footer");

            $("footer .menu__main a").removeClass("hover");
            $("footer .menu__right").addClass("d-none");
            $("footer .menu__right")
              .eq($("footer .menu__main a.active").index())
              .removeClass("d-none");
          }
        );

      $(".search__open").click(function () {
        $(".search__cont").slideDown();
        $(".search__close").show();
        $(this).hide();
        $(".search .form-control").focus();
      });
      $(".search__close").click(function () {
        $(".search__cont").slideUp();
        $(".search__open").show();
        $(this).hide();
      });

      $("#bank-currency-select").change(function () {
        var value = $(this).val();
        if (value === "-1") {
          $(".label-listing p").show();
        } else {
          $(".label-listing p").hide();
          $(`.label-listing p[data-currency="${value}"]`).show();
        }
      });

      if (app.getMobileOperatingSystem() === "Android") {
        $("#get-the-app").attr(
          "href",
          $("#get-the-app").attr("data-playstore")
        );
      }

      if (!app.isMobile) {
        var heights = [];

        $(".label-listing")
          .find("p")
          .each(function () {
            heights.push($(this).outerHeight());

            //console.log($(this).height())
          });

        var maxHeight = Math.max(...heights);
        $(".label-listing").find("p").css("min-height", maxHeight);
      }

      $("#show-team").click(function () {
        var tab = parseInt($(this).attr("data-tab")) - 1;

        $(".tabs-nav__list").eq(tab).trigger("click");

        window.scrollTo(0, $(".tabs-nav__list").eq(1).offset().top);
      });

      $("#existing-customer").change(function () {
        if ($(this).is(":checked")) {
          $("#fe276").val("Yes");
        } else {
          $("#fe276").val("No");
        }
      });

      $(".banking-services__content").each(function () {
        $(this).css("max-height", $(this).height());
      });

      $(".menu__main").each(function (index) {
        var col = $(".menu__main a.active").get()[index];
        var div = $(".menu__main").get()[index];
        if (col != null && div != null) {
          div.scrollLeft = col.offsetLeft - 50;
        }
      });
    },
    lazyLoad: function () {
      var lazyLoadInstance = new LazyLoad({
        // Your custom settings go here
      });
    },
    swiper: function () {
      let spotlightSwiperTimer = undefined;

      if ($(".spotlight .swiper-slide").length === 1) {
        $(".spotlight img, .spotlight video, .spotlight iframe").addClass(
          "spotlight__single"
        );
      }

      const spotlightSwiper = new Swiper(".spotlight .swiper", {
        pagination: {
          el: ".spotlight__pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="${className}">${$(".spotlight .swiper-slide")
              .eq(index)
              .data("slide-caption")}</span>`;
          },
        },
        speed: 1000,
        autoplay: {
          delay: 7000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 0,

        on: {
          slideChange: function (swiper) {
            //console.log(swiper.activeIndex)
            if (
              $(".spotlight .swiper-slide").eq(swiper.activeIndex).find("video")
                .length === 1
            )
              $(".spotlight .swiper-slide")
                .eq(swiper.activeIndex)
                .find("video")
                .get(0)
                .play();
          },
          init: function (swiper) {},
        },
      });
      new Swiper(".right-product__items .swiper", {
        slidesPerView: 2.2,
        spaceBetween: 15,

        breakpoints: {
          1200: {
            slidesPerView: 3.5,
            // spaceBetween: 20
          },
          1400: {
            slidesPerView: 5,
            // spaceBetween: 20
          },
        },
      });

      let tabBannerSwiperUpdated = false;
      const tabBannerSwiper = new Swiper(".tab-sliding-banner .swiper", {
        pagination: {
          el: ".tab-sliding-banner__pagination",
          clickable: true,

          renderBullet: function (index, className) {
            return `<span class="${className}">${$(
              ".tab-sliding-banner .swiper-slide"
            )
              .eq(index)
              .data("slide-caption")}</span>`;
          },
        },
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        autoHeight: true,

        on: {
          slideChange: function (swiper) {
            //console.log(swiper.activeIndex)
            if (
              $(".tab-sliding-banner .swiper-slide")
                .eq(swiper.activeIndex)
                .find("video").length === 1
            )
              $(".tab-sliding-banner .swiper-slide")
                .eq(swiper.activeIndex)
                .find("video")
                .get(0)
                .play();
          },
          init: function (swiper) {
            console.log("init");
            if (!tabBannerSwiperUpdated) {
              // tabBannerSwiperUpdated = true
              setInterval(() => {
                tabBannerSwiper.update();
              }, 1000);
            }
          },
        },
      });

      const newsLargeSlider = $(".news__slider--lg").length;

      const newsSwiper = new Swiper(".news__slider .swiper", {
        pagination: {
          el: ".news__slider__pagination",
          clickable: true,
        },
        preloadImages: false,
        lazy: true,
        slidesPerView: 1.1,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: newsLargeSlider > 0 ? 3.5 : 2.2,
            spaceBetween: 20,
          },
        },
      });

      const jobsSwiper = new Swiper(".jobs--slider .swiper", {
        preloadImages: false,
        lazy: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        breakpoints: {
          900: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1400: {
            slidesPerView: 3.5,
            spaceBetween: 20,
          },
        },
      });

      const featureSliderMob = new Swiper(".feature-slider-lg-mob .swiper", {
        pagination: {
          el: ".feature-slider-lg-mob__pagination",
          clickable: true,
        },
        preloadImages: false,
        lazy: true,
        slidesPerView: 1,
        spaceBetween: 20,
      });

      app.tabSwiper = new Swiper(".dynamic-banking__slider .swiper", {
        pagination: {
          el: ".tab-swiper-pagination",
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        preloadImages: false,
        lazy: true,
        on: {
          slideChange: function (swiper) {
            // //console.log(swiper.activeIndex)
            $(".tabs-nav__list")
              .eq(swiper.activeIndex)
              .find(".tabs-nav__link")
              .click();
          },
        },
      });

      app.lifestyleSwiper = new Swiper(".lifestyle__swiper-slider .swiper", {
        pagination: {
          el: ".lifestyle__swiper-slider__pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="${className}">${$(
              ".lifestyle__swiper-slider .swiper-slide"
            )
              .eq(index)
              .data("slide-caption")}</span>`;
          },
        },
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,

        on: {
          slideChange: function (swiper) {
            //console.log(swiper.activeIndex)
            app.disableAnimation = false;
            $(".lifestyle__card").eq(swiper.activeIndex).trigger("click");
            $(".lifestyle__details").hide();
            $(".lifestyle__details").eq(swiper.activeIndex).show();
          },
        },
      });

      const threeCardSwiper = new Swiper(".three-card-swiper", {
        slidesPerView: "auto",
        spaceBetween: 20,
        breakpoints: {
          320: {
            slidesPerView: 1.2,
          },
          1000: {
            slidesPerView: 3,
          },
        },
      });
      const twoCardSwiper = new Swiper(".two-card-swiper", {
        slidesPerView: "auto",
        spaceBetween: 20,
        breakpoints: {
          320: {
            slidesPerView: 1.2,
          },
          1000: {
            slidesPerView: 2,
          },
        },
      });
    },
    productFinder: function () {
      $(".spotlight .product-finder").hover(
        function () {
          gsap.to(".spotlight .tools__path", {
            duration: 0.5,
            x: -5.026,
            y: -5.038,
            morphSVG: ".spotlight .tools__path1",
          });
          gsap.to(".spotlight .product-finder path", {
            duration: 0.5,
            fill: "#fff",
            stroke: "#fff",
          });
          //console.log("in")
        },
        function () {
          //console.log("out")
          gsap.to(".spotlight .tools__path", {
            duration: 0.5,
            x: 0.25,
            y: 0.25,
            morphSVG: ".spotlight .tools__path",
          });
          gsap.to(".spotlight .product-finder path", {
            duration: 0.5,
            fill: "none",
            stroke: "#263743",
          });
        }
      );
      $(".floating-tools .product-finder").hover(
        function () {
          gsap.to(".floating-tools .tools__path", {
            duration: 0.5,
            x: -5.026,
            y: -5.038,
            morphSVG: ".floating-tools .tools__path1",
          });
          gsap.to(".floating-tools .product-finder path", {
            duration: 0.5,
            fill: "#fff",
            stroke: "#fff",
          });
          //console.log("in")
        },
        function () {
          //console.log("out")
          gsap.to(".floating-tools .tools__path", {
            duration: 0.5,
            x: 0.25,
            y: 0.25,
            morphSVG: ".floating-tools .tools__path",
          });
          gsap.to(".floating-tools .product-finder path", {
            duration: 0.5,
            fill: "none",
            stroke: "#263743",
          });
        }
      );

      const items = document.querySelectorAll(".spotlight");

      if (items.length === 0) {
        $(".floating-tools__btn").addClass("visible");
      }

      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              $(".floating-tools__btn").removeClass("visible active");
              $(".floating-tools .tools").removeClass("active");
            } else {
              $(".floating-tools__btn").addClass("visible");
            }
          });
        },
        { rootMargin: "0px 0px 0px 0px" }
      );

      items.forEach((item) => {
        observer.observe(item);
      });
    },
    bankServices: function () {
      var plusIcon = $(".banking-services .plus-cut-icon");
      plusIcon.on("click", function () {
        $(this)
          .parents(".banking-services")
          .toggleClass("banking-services--expand");
      });

      var plusIcon2 = $(".banking-program-card .plus-cut-icon");
      plusIcon2.on("click", function () {
        $(this)
          .parents(".banking-program-card")
          .toggleClass("banking-program-card--show");
      });
    },
    tabs() {
      const tabNav = $(".tabs__head");
      const activeClass = "active";
      let $this;
      let currentIndex;

      $.each(tabNav, function (index, elem) {
        const selector = $(elem);
        const tabNavList = selector.find("> ul > li");
        const tabPane = selector.parent().find(".tabs__pane");
        tabNavList.eq(0).find("> a").addClass(activeClass);
        tabPane.eq(0).addClass(activeClass);

        tabNavList.on("click", function (e) {
          $this = $(this);

          if (app.isMobile) {
            //	$this.find('a').get(0).scrollIntoView(true)
          } else {
            //	$this.find('a').get(0).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
          }

          // if (!$this.parent().hasClass('js-hash-clickable')) {
          // 	// debugger
          // 	e.preventDefault()
          // }
          currentIndex = $this.index();
          if ($this.parent().hasClass("js-has-slide-to"))
            app.tabSwiper.slideTo(currentIndex);

          tabPane.removeClass(activeClass);
          if ($this.closest(".tabs__head").next(".tabs__body").length) {
            $this
              .closest(".tabs__head")
              .next(".tabs__body")
              .find("> .tabs__pane")
              .eq(currentIndex)
              .addClass(activeClass);
          } else {
            $this
              .closest(".tabs__head")
              .next(".tabs__outer")
              .find("> .tabs__body")
              .find("> .tabs__pane")
              .eq(currentIndex)
              .addClass(activeClass);
          }

          // console.log($this.closest('.tabs__head').next().find('.tabs__pane').eq(currentIndex).find('.tabs-nav__list .tabs-nav__link').eq(0).trigger('click'))
          tabNavList.find("> a").removeClass(activeClass);

          if (!$this.find("> a").hasClass(activeClass)) {
            $this.find("> a").addClass(activeClass);
          }

          if ($this.parents(".tabs__body").length === 0) {
            $(".tabs__pane.active")
              .find(".tabs-nav__list .tabs-nav__link")
              .eq(0)
              .trigger("click");
          }
          // console.log("clicked")

          $this.parents(".tabs__head");

          var col = $this.get()[0];
          var div = $this.parents(".tabs__head").get()[0];

          if (col != null && div != null) {
            div.scrollLeft = col.offsetLeft - 50;
          }
        });
      });
      let url = window.location;
      let qs = url.hash;
      let qsText = qs.slice(1, qs.length);

      if (qsText) {
        $('[href="#' + qsText + '"]').click();

        // if ($('.js-hash-clickable').length) {
        // 	$('[href="#' + qsText + '"]').click();
        // 	$('html, body').animate({
        // 		scrollTop: $('[href="#' + qsText + '"]').offset().top - 100
        // 	}, 300);
        // } else {
        // 	$('.tabs-nav__list').each(function (i, elem) {
        // 		if ($(elem).find('.tabs-nav__link').text().toLowerCase() === qsText) {
        // 			$(elem).find('.tabs-nav__link').click();
        // 			$('html, body').animate({
        // 				scrollTop: $('.tabs__body').offset().top
        // 			}, 300);
        // 		}
        // 	});
        // }
      }
    },

    rangeSlider() {
      let homeLoanAmount = $("#home-loan-amount").attr("data-min");
      let homeLoanTenure = $("#home-loan-tenure").attr("data-min");
      let personalLoanAmount = $("#personal-loan-amount").attr("data-min");
      let personalLoanTenure = $("#personal-loan-tenure").attr("data-min");
      let autoLoanAmount = $("#auto-loan-amount").attr("data-min");
      let autoLoanTenure = $("#auto-loan-tenure").attr("data-min");

      var $range = $(".js-range-slider"),
        min = 1,
        max = 10;

      $range.ionRangeSlider({
        skin: "modern",
        type: "single",
        min: min,
        max: max,
        from: 10,
        prettify: function (num) {
          var tmp_min = min,
            tmp_max = max,
            tmp_num = num;

          if (min < 0) {
            tmp_min = 0;
            tmp_max = max - min;
            tmp_num = num - min;
            tmp_num = tmp_max - tmp_num;
            return tmp_num + min;
          } else {
            num = max - num;
            return num;
          }
        },
      });

      $(".range-slider").each(function () {
        var $this = $(this),
          rangeInput = $(this);

        var min =
          $this.data("min") === "" || $this.data("min") === undefined
            ? 5
            : $this.data("min");
        var max =
          $this.data("max") === "" || $this.data("max") === undefined
            ? 30
            : $this.data("max");

        // debugger

        //console.log(min + ' : min');
        //console.log(max + ' : max');

        var reverse = function (num) {
          return max - (num - min);
        };

        rangeInput.ionRangeSlider({
          prettify_enabled: true,
          prettify_separator: ",",

          from: app.culture === "ar" ? max : min,

          prettify: function (num) {
            if (app.culture === "ar") {
              return (num = reverse(num));
              /* var tmp_min = min,
								tmp_max = max,
								tmp_num = num;

							if (min < 0) {
								tmp_min = 0;
								tmp_max = max - min;
								tmp_num = num - min;
								tmp_num = tmp_max - tmp_num;
								return tmp_num + min;
							} else {
								num = max - num;
								return num + 1;
							} */
            } else {
              return num;
            }
          },

          /* prettify: function (num) {
						//console.log(num);

						if (app.isRTL) {
							num = reverse(num);
						}

						var tmp_min = min,
							tmp_max = max,
							tmp_num = num;

						if (min < 0) {
							tmp_min = 0;
							tmp_max = max - min;
							tmp_num = num - min;
							tmp_num = tmp_max - tmp_num;
							return tmp_num + min;
						} else {
							num = max - num;
							return num;
						}




					}, */

          /* 	onStart: function (data) {
							fixPosition(data.slider, 0);
						}, */

          onChange: function (data) {
            if ($(data.input).attr("id") === "home-loan-amount") {
              homeLoanAmount = data.from_pretty;
            }
            if ($(data.input).attr("id") === "home-loan-tenure") {
              homeLoanTenure = data.from_pretty;
            }
            if ($(data.input).attr("id") === "personal-loan-amount") {
              personalLoanAmount = data.from_pretty;
            }
            if ($(data.input).attr("id") === "personal-loan-tenure") {
              personalLoanTenure = data.from_pretty;
            }
            if ($(data.input).attr("id") === "auto-loan-amount") {
              autoLoanAmount = data.from_pretty;
            }
            if ($(data.input).attr("id") === "auto-loan-tenure") {
              autoLoanTenure = data.from_pretty;
            }

            app._calculateLoan(
              homeLoanAmount,
              homeLoanTenure,
              parseFloat($("#home-loan-values").attr("data-interest")),
              $("#home-loan-values")
            );
            app._calculateLoan(
              personalLoanAmount,
              personalLoanTenure,
              parseFloat($("#personal-loan-values").attr("data-interest")),
              $("#personal-loan-values")
            );
            app._calculateLoan(
              autoLoanAmount,
              autoLoanTenure,
              parseFloat($("#auto-loan-values").attr("data-interest")),
              $("#auto-loan-values")
            );
          },
        });
      });

      $(".range-slider-100").ionRangeSlider({
        prettify_enabled: true,
        prettify_separator: ",",
        onChange: function (data) {
          if ($(data.input).attr("id") === "home-loan-amount") {
            homeLoanAmount = data.from;
          }
          if ($(data.input).attr("id") === "home-loan-tenure") {
            homeLoanTenure = data.from;
          }
          if ($(data.input).attr("id") === "personal-loan-amount") {
            personalLoanAmount = data.from;
          }
          if ($(data.input).attr("id") === "personal-loan-tenure") {
            personalLoanTenure = data.from;
          }
          if ($(data.input).attr("id") === "auto-loan-amount") {
            autoLoanAmount = data.from;
          }
          if ($(data.input).attr("id") === "auto-loan-tenure") {
            autoLoanTenure = data.from;
          }

          app._calculateLoan(
            homeLoanAmount,
            homeLoanTenure,
            parseFloat($("#home-loan-values").attr("data-interest")),
            $("#home-loan-values")
          );
          app._calculateLoan(
            personalLoanAmount,
            personalLoanTenure,
            parseFloat($("#personal-loan-values").attr("data-interest")),
            $("#personal-loan-values")
          );
          app._calculateLoan(
            autoLoanAmount,
            autoLoanTenure,
            parseFloat($("#auto-loan-values").attr("data-interest")),
            $("#auto-loan-values")
          );
        },
      });
    },

    customSelect: function () {
      $(".custom-select").selectize({
     
        
     
      });

      $('.selectize-input input').prop('disabled', true);

      $("#field1").change(function () {
        //console.log($(this).val())

        $(".form-btn").removeClass("disabled").attr("href", $(this).val());
      });
    },

    lifestyleAnimation: function () {
      var grid = $(".lifestyle__card");
      $(".lifestyle__details").eq(0).show();

      if (grid.length !== 0) {
        // app.disableAnimation ;

        var placeholder = $(".lifestyle__placeholder");
        var container = $(".lifestyle__slider").offset().left;

        grid.eq(0).css({
          left: placeholder.eq(1).offset().left - container,
          width: placeholder.eq(1).width(),
        });
        grid.eq(1).css({
          left: placeholder.eq(0).offset().left - container,
          width: placeholder.eq(0).width(),
        });
        grid.eq(2).css({
          left: placeholder.eq(2).offset().left - container,
          width: placeholder.eq(2).width(),
        });

        grid.click(function () {
          //console.log(app.disableAnimation)

          if (!app.disableAnimation) {
            //	//console.log()
            app.lifestyleSwiper.slideTo($(this).attr("data-original-index"));
            $(
              ".lifestyle .swiper-pagination .swiper-pagination-bullet"
            ).removeClass(" swiper-pagination-bullet-active");
            $(".lifestyle .swiper-pagination .swiper-pagination-bullet")
              .eq($(this).attr("data-original-index"))
              .addClass("swiper-pagination-bullet-active");

            app.disableAnimation = true;

            ////console.log($(this).data().index)

            if ($(this).attr("data-index") === "0") {
              $(this)
                .css({
                  left: placeholder.eq(1).offset().left - container,
                  width: placeholder.eq(1).width(),
                })
                .removeClass("lifestyle__card--first")
                .addClass("lifestyle__card--active");
              $(".lifestyle__card[data-index=1]")
                .css({
                  left: placeholder.eq(0).offset().left - container,
                  width: placeholder.eq(0).width(),
                })
                .addClass("lifestyle__card--first")
                .removeClass("lifestyle__card--active");

              setTimeout(() => {
                $(".lifestyle__card[data-index=1]").attr("data-index", "0");
                $(this).attr("data-index", "1");
                app.disableAnimation = false;
              }, 300);
            } else if ($(this).attr("data-index") === "2") {
              $(this)
                .css({
                  left: placeholder.eq(1).offset().left - container,
                  width: placeholder.eq(1).width(),
                })
                .removeClass("lifestyle__card--last")
                .addClass("lifestyle__card--active");
              $(".lifestyle__card[data-index=1]")
                .css({
                  left: placeholder.eq(2).offset().left - container,
                  width: placeholder.eq(2).width(),
                })
                .addClass("lifestyle__card--last")
                .removeClass("lifestyle__card--active");

              setTimeout(() => {
                $(".lifestyle__card[data-index=1]").attr("data-index", "2");
                $(this).attr("data-index", "1");
                app.disableAnimation = false;
              }, 500);
            }
          }
        });

        $(".lifestyle .swiper-pagination-bullet").click(function () {
          $(".lifestyle__card").eq($(this).index()).trigger("click");
          // console.log()
        });
      }
    },

    googleMap: function () {
      let msg = $("#atm-location").attr("data-available") || "available in";

      if ($("#atm-location").length != 0) {
        const url = `${$("#atm-location").attr("data-url")}?pageId=${$("#branchesListParentId").val()}&culture=${app.culture}`;

        var markup = ``;

        $.ajax({
          url,
          contentType: "application/json",
          dataType: "json",
        }).done(function (data) {
          //	if(data !== 'undefined') return false
          console.log(data);
          console.log(data.Result);
          //	msg = data.Result.CurrenciesAvailabilityMsg
          loadBranches(data.Result.Locations, true);
          loadTypes(data.Result.Types);
          $(".atm-location__list").click(function () {
            $(".atm-location__list").removeClass("active");

            $(this).addClass("active");

            $(".atm-location__map-iframe iframe").attr(
              "src",
              $(this).attr("data-url")
            );
          });

          $(".atm-location .tabs-nav__link ").click(function () {
            $(".atm-location__list").removeClass("d-none");

            $(".atm-location .tabs-nav__link").removeClass("active");
            $(this).addClass("active");

            var type = $(this).attr("data-type");

            $(".atm-location__list").each(function () {
              if (type == 0) {
                $(".atm-location__list").removeClass("active");
                return false;
              }

              if ($(this).attr("data-type") !== type) {
                $(this).addClass("d-none");
              }
            });

            $("#atm-location-filter").val(-1);
          });

          $("#atm-location-filter").change(function () {
            var currency = $(this).val();

            if (currency == -1) {
              $(".atm-location__list").removeClass("d-none");
              return false;
            }

            $(".atm-location__list").each(function () {
              // debugger
              console.log($(this).attr("data-currency").includes(currency));
              if ($(this).attr("data-currency").includes(currency)) {
                $(this).removeClass("d-none");
              } else {
                $(this).addClass("d-none");
              }
            });

            if ($(".atm-location__list:visible").length === 0) {
              $(".atm-location__error").show();
            } else {
              $(".atm-location__error").hide();
            }
          });

          $('.atm-location__list').eq(0).trigger('click')
        });

        function loadTypes(data = []) {
          var types = "";

          for (let index = 0; index < data.length; index++) {
            types += `  <li  class="tabs-nav__list"><a class="tabs-nav__link ${
              index === 0 ? "active" : ""
            }"  data-type='${data[index].Type}' href="javascript:void(0)">${
              data[index].CategoryName
            }</a></li>`;
          }

          $(".atm-location .tabs-nav").append(types);
        }

        function loadBranches(data = [], loadMarkers = false) {
          for (let index = 0; index < data.length; index++) {
         
            var currencies = data[index].CurrenciesId || [];
            var currencyCodes = data[index].Currencies || [];

            markup += `<div class="atm-location__list ${
              index === 0 ? "active" : ""
            }" data-currency='${currencies}' data-type='${
              data[index].LocationType
            }' data-title='${data[index].LocationName}' data-url='${
              data[index].EmebededGoogleMapsLink
            }'>
					<div class="atm-location__list-left">
					  <h4 class="h4">${data[index].LocationName} <br/>  
					  
					 
					  </h4>
					  <div class='${
              data[index].NormalTimings
                ? " atm-location__copy"
                : "d-none atm-location__copy"
            }'>

					
					  
					  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
					  <g  data-name="Group 13954" transform="translate(-1393.969 -5402.5)">
						<path data-name="Path 6308" d="M119.5,62.6a7.5,7.5,0,1,0-7.5-7.5A7.516,7.516,0,0,0,119.5,62.6Zm0-14.294a6.794,6.794,0,1,1-6.794,6.794A6.808,6.808,0,0,1,119.5,48.306Z" transform="translate(1282.469 5355.4)" fill="#0095c8" stroke="#0095c8" stroke-width="1"/>
						<path  data-name="Path 6309" d="M340.6,125.691l.555-.308-1.742-3.161V117.6H338.8v4.7l.031.154Z" transform="translate(1062.765 5288.617)" fill="#0095c8" stroke="#0095c8" stroke-width="1"/>
					  </g>
					</svg>
					
					<p>
					 <span>
					   ${data[index].WorkingDays}  ${data[index].NormalTimings} 
					   </span>

					   <span>
					   ${data[index].SaturdayTimings} 
					  </span>
					  <span>
					   ${data[index].BreakTimings} 
					   </span>
					   <span>
					   ${data[index].FridayTimings} 
					   </span>
					   </p>
					  </div>


					  <div class='${
              data[index].Phone
                ? " atm-location__copy"
                : "d-none atm-location__copy"
            }'>
					  
					  <svg xmlns="http://www.w3.org/2000/svg" width="16.924" height="16.139" viewBox="0 0 16.924 16.139">
					  <g   data-name="Group 13953" transform="translate(-1477.779 -5558.258)">
						<path   data-name="Path 6235" d="M13.58,9.213c-.976-.5-1.951-.96-2.689-1.307a.839.839,0,0,0-1.114.334c-.034.049-.069.1-.1.147-.18.254-.365.516-.56.762-.319.4-.45.437-.934.239A8.8,8.8,0,0,1,3.939,5.662a.414.414,0,0,1,.038-.572c.054-.059.11-.12.162-.179a4.95,4.95,0,0,0,.606-.745,1.087,1.087,0,0,0,.139-.857C4.54,2.383,4.147,1.472,3.739.544a.819.819,0,0,0-.488-.46A2.146,2.146,0,0,0,1.178.53,3.881,3.881,0,0,0,.3,1.816,4.137,4.137,0,0,0,0,3.343v.01l0,.01c.007.062.011.126.015.187.011.139.021.282.044.424A7.71,7.71,0,0,0,1.53,7.136,17.336,17.336,0,0,0,3.1,9.087a13.883,13.883,0,0,0,1.815,1.625A12.561,12.561,0,0,0,7,11.973a12.912,12.912,0,0,0,2.378.858,4.653,4.653,0,0,0,1.143.151,3.94,3.94,0,0,0,2.08-.6A2.742,2.742,0,0,0,13.92,9.793a.736.736,0,0,0-.341-.58Zm-.025.585a2.375,2.375,0,0,1-1.142,2.273,3.666,3.666,0,0,1-2.943.4A13.028,13.028,0,0,1,1.832,6.925,7.37,7.37,0,0,1,.423,3.914C.4,3.788.393,3.657.382,3.52c0-.061-.01-.121-.015-.183A3.493,3.493,0,0,1,1.437.789,1.752,1.752,0,0,1,3.18.44a.5.5,0,0,1,.226.247c.4.924.8,1.83,1.137,2.747a.749.749,0,0,1-.106.536,4.632,4.632,0,0,1-.563.69c-.054.059-.111.12-.165.182A.775.775,0,0,0,3.628,5.85a10.267,10.267,0,0,0,1.885,2.3A8.713,8.713,0,0,0,8.041,9.724a1.234,1.234,0,0,0,.755.121,1.161,1.161,0,0,0,.6-.473c.2-.252.388-.519.572-.776.034-.049.069-.1.1-.146a.477.477,0,0,1,.66-.215c.737.344,1.707.8,2.678,1.3a.424.424,0,0,1,.143.262Z" transform="translate(1480.383 5558.825) rotate(9)" fill="#0095c8" stroke="#0095c8" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
					  </g>
					</svg>
					
					
					 <p>
					 
					<a href=' tel:${data[index].Phone} '> ${data[index].Phone} </a>
					 
					 </p>
					  </div>
					  <div class='${
              currencyCodes.length !== 0
                ? " atm-location__copy"
                : "d-none atm-location__copy"
            }'>
					  <svg style='margin-top:7px'  xmlns="http://www.w3.org/2000/svg" width="15" height="9.5" viewBox="0 0 20 12.67">
					  <g  data-name="Group 15234">
						<path  data-name="Path 12700" d="M19.67,0H.33A.333.333,0,0,0,0,.33v10a.333.333,0,0,0,.33.33H19.67a.333.333,0,0,0,.33-.33V.33A.333.333,0,0,0,19.67,0Zm-.33,10H.67V.67H19.33V10Z" fill="#0095c8"/>
						<path  data-name="Path 12701" d="M66.172,72.172a2.006,2.006,0,0,1,2,2,.333.333,0,0,0,.33.33h12.67a.333.333,0,0,0,.33-.33,2.006,2.006,0,0,1,2-2,.333.333,0,0,0,.33-.33v-3.33a.333.333,0,0,0-.33-.33,2.006,2.006,0,0,1-2-2,.333.333,0,0,0-.33-.33H68.512a.333.333,0,0,0-.33.33,2.006,2.006,0,0,1-2,2,.333.333,0,0,0-.33.33v3.33a.333.333,0,0,0,.33.33Zm.33-3.35a2.674,2.674,0,0,0,2.31-2.31h12.04a2.674,2.674,0,0,0,2.31,2.31v2.71a2.674,2.674,0,0,0-2.31,2.31H68.822a2.674,2.674,0,0,0-2.31-2.31v-2.71Z" transform="translate(-64.842 -64.842)" fill="#0095c8"/>
						<path  data-name="Path 12702" d="M459.4,157.916a3,3,0,1,0-3-3A3.009,3.009,0,0,0,459.4,157.916Zm0-5.33a2.33,2.33,0,1,1-2.33,2.33A2.332,2.332,0,0,1,459.4,152.586Z" transform="translate(-449.4 -149.586)" fill="#0095c8"/>
						<rect  data-name="Rectangle 6114" width="1.33" height="0.67" transform="translate(13.67 5)" fill="#0095c8"/>
						<rect  data-name="Rectangle 6115" width="1.33" height="0.67" transform="translate(5 5)" fill="#0095c8"/>
						<rect  data-name="Rectangle 6116" width="19.33" height="0.67" transform="translate(0.33 11)" fill="#0095c8"/>
						<rect  data-name="Rectangle 6117" width="19.33" height="0.67" transform="translate(0.33 12)" fill="#0095c8"/>
					  </g>
					</svg>
					
					
					
					 <p>

					 ${currencyCodes.length === 0 ? "" : `${msg} ${currencyCodes.toString()}`}
					 
					 
					 
					 </p>
					  </div>
					 
					</div>
					 
				  </div>`;
          }

          $("#atm-location-list").append(markup);
        }

        $("#search-location").keyup(function () {
          var val = $(this).val().toLowerCase();
          $(".atm-location__list").hide();
          $(".atm-location__list").each(function () {
            // $('.atm-location__list').hide()
            if ($(this).attr("data-title").toLowerCase().includes(val)) {
              $(this).show();
            }
            if ($(".atm-location__list:visible").length === 0) {
              $(".atm-location__error").show();
            } else {
              $(".atm-location__error").hide();
            }
          });
        });
      }
    },

    imageVideo() {
      // Gets the video src from the data-src on each button
      var $videoSrc;
      $(".image-video__v-image .btn-play").click(function () {
        $videoSrc = $(this).data("src");
        $(".image-video__overlay").fadeIn();
        $(".image-video__overlay-iframe #video").attr(
          "src",
          $videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0"
        );
      });
      $(".image-video__overlay .close").click(function () {
        $(".image-video__overlay").fadeOut();
        $(".image-video__overlay-iframe #video").attr("src", "");
      });
    },
    _calculateLoan: function (total, years, ratePercent, elem) {
      console.log(total, years);

      const monthlyRate =
        total *
        (((ratePercent / 12 / 100) *
          Math.pow(1 + ratePercent / 12 / 100, years * 12)) /
          (Math.pow(1 + ratePercent / 12 / 100, years * 12) - 1));
      const months = years * 12;
      const totalAmount = monthlyRate * months;
      const totalInterest = totalAmount - total;

      elem.find(".loan-tenure").text(months);
      elem.find(".loan-interest").text(
        totalInterest.toLocaleString(undefined, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        })
      );
      elem.find(".loan-total").text(
        totalAmount.toLocaleString(undefined, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        })
      );
      elem.find(".loan-monthly").text(
        monthlyRate.toLocaleString(undefined, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        })
      );
    },

    accordion: function () {
      var elem = $(".accordion"),
        elemTarget = elem.find(".accordion__heading"),
        activeClass = "accordion--active",
        contentClass = ".accordion__content",
        headerHeight = $(".header").height(),
        topOffsetValue;
      $(".tabs__cont").on("click", ".accordion__heading", function (e) {
        e.stopPropagation();
        // //console.log("accordion");
        var $this = $(this);
        $this.parent(elem).toggleClass(activeClass);
        if ($this.parent(elem).hasClass(activeClass)) {
          $this.parent(elem).find(contentClass).stop().slideDown(200);
          $this
            .parent(elem)
            .siblings()
            .find(contentClass)
            .stop()
            .slideUp(500, function () {
              //	topOffsetValue = $this.offset().top;
              //$("html").scrollTop(topOffsetValue - headerHeight)
            });
          $this.parent(elem).siblings().removeClass(activeClass);
        } else {
          $this.parent(elem).find(contentClass).stop().slideUp();
        }
      });

      $(".accordion__icon").click(function () {
        $(this).next(".accordion__heading").trigger("click");
      });
      // multi accordion
      $(".multi-toggle__icon").click(function (e) {
        var $this = $(this);

        $this.parent().find(".inner").eq(0).slideToggle().toggleClass("show");
        $this.toggleClass("active");
        e.stopPropagation();
        console.log($this);
        // if ($this.next().hasClass('show')) {
        // 	$this.removeClass('active');
        // 	$this.next().removeClass('show');
        // 	$this.next().slideUp(350);
        // } else {
        // 	$this.parent().parent().find('li .inner').removeClass('show');
        // 	$this.parent().parent().find('li .inner').slideUp(350);
        // 	$this.addClass('active');
        // 	$this.next().toggleClass('show');
        // 	$this.next().slideToggle(350);
        // }
      });
    },

    roundSlier() {
      if (!$("#estimate-slider").length) return false;

      function _chartValues(obj) {
        const chartValues = [
          "100,000",
          "200,000",
          "300,000",
          "400,000",
          "500,000",
          "600,000",
          "700,000",
          "800,000",
          "900,000",
          "1000,000",
        ];
        $("#chart-value").text(chartValues[obj.value]);
      }

      $("#estimate-slider").roundSlider({
        radius: 85,
        sliderType: "min-range",
        min: 0,
        max: 9,
        value: 2,
        radius: app.isMobile ? 140 : 165,
        width: app.isMobile ? 20 : 30,
        mouseScrollAction: true,
        editableTooltip: false,
        showTooltip: false,
        beforeCreate: function (obj) {
          // //console.log(obj);
          _chartValues(obj);
        },
        drag: function (obj) {
          // //console.log(obj.value);
          _chartValues(obj);
        },
        change: function (obj) {
          // //console.log(obj);
          _chartValues(obj);
        },
        stop: function (obj) {
          // //console.log(obj);
        },
        tooltipFormat: tooltipVal1,
      });

      function tooltipVal1(args) {
        var months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        return ` <h1> ${months[args.value]} </h1> `;
      }
    },

    random() {
      $(".js-right-slide__btn").on("click", function () {
        $(".js-right-slide").toggleClass("js-right-slide--active");
        $(this).text(
          $(this).hasClass("js-right-slide__btn--active")
            ? $(this).data("slide-before")
            : $(this).data("slide-after")
        );
        $(this).toggleClass("js-right-slide__btn--active");
      });
      $(".js-back-btn-slide").on("click", function () {
        $(".js-right-slide").removeClass("js-right-slide--active");
        $(".js-right-slide__btn").removeClass("js-right-slide__btn--active");
        $(".js-right-slide__btn").text(
          $(".js-right-slide__btn").data("slide-before")
        );
      });
    },

    iban: function () {
      var isFormValid = false;

      $(".iban-form").validate({
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid

        highlight: function (element) {
          $(element).parent().addClass("field-error");

          $(element).parents("fieldset").find("legend").addClass("field-error");
        },
        unhighlight: function (element) {
          $(element).parent().removeClass("field-error");
          $(element)
            .parents("fieldset")
            .find("legend")
            .removeClass("field-error");
        },
        submitHandler: function (form) {
          //	form.submit();
          //	alert('form is valid')
          isFormValid = true;
        },
      });
      $(".iban-form").on("submit", function (e) {
        e.preventDefault();

        //generateCaptchaToken()

        if (!isFormValid) {
          return false;
        } else {
          $(".iban-bumber input").val(
            actionIbanForm(
              $("#acc-number").val(),
              $("#dynamicmodel-branch_code").val()
            )
          );
          $(".ban-generator__icon").css("opacity", "1");
          return false;
        }
      });

      // $('.ban-generator .btn').click(function () {

      // 	$('.iban-bumber input').val(actionIbanForm($('#acc-number').val(), $('#dynamicmodel-branch_code').val()))
      // 	$('.ban-generator__icon').css('opacity', "1")

      // })
    },
    copyToClipBoard: function () {
      var copyTextBtn = document.getElementById("copy-code-btn");
      var copyText = document.getElementById("copy-code");

      if (copyTextBtn !== null) {
        copyTextBtn.addEventListener("click", function () {
          copyText.select();
          copyText.setSelectionRange(0, 99999);
          document.execCommand("copy");
          $("#copy-code-tip").css("opacity", "1");
        });
      }
    },

    gridSlideAnimation() {
      let parent = $(".feature-grid-lg__content");
      let gridCopy = $(".feature-grid-lg__copy");

      gridCopy.each(function (i, elem) {
        console.log($(elem).height());
        // console.log($(elem).outerHeight());
        //$('.feature-grid-lg__slider-img').eq(i).height($(elem).height() + 40);
        if (i + 1 === $(".feature-grid-lg__slider-img").length) {
          $(".feature-grid-lg__slider-img")
            .eq(i)
            .height($(elem).height() + 80);
        }
      });

      parent.scroll(function (ev) {
        // console.log(parent.scrollTop());
        $(".feature-grid-lg__scroll").css({
          transform: `translateY(-${parent.scrollTop()}px)`,
        });
      });

      let counter = 0;
      let wrapper = $(".feature-slider-lg__wrapper");
      let wrapperHeight = wrapper.height();

      wrapper.on("click", function () {
        console.log("counter",counter)
       
        if (
          $(".feature-slider-lg__slider-img, .feature-slider-lg__copy").length /
            2 >
          counter + 1
        ) {
          counter++;
          $(".feature-slider-lg__scroll, .feature-slider-lg__content").css({
            transform: `translateY(-${(wrapperHeight + 2) * counter}px)`,
          });

          if ($("[data-svg-inverse]").data("svg-inverse") === counter) {
            console.log(true);
            wrapper.addClass("feature-slider-lg__wrapper--svg-inverse");
          }
        }
        if($('.feature-slider-lg__copy').length-1 === counter){
          counter = 0
        }
      });
    },

    _searchFAQData(data) {
      const searchInput = $("#search-input");
      const searchContainer = $("#search-container");
      const searchContainerAccordion = searchContainer.find(
        ".accordion-wrapper--append"
      );
      const fetchedData = data;
      const defaultAccordion = $("#accordianid");
      const categoryTabs = $(".faq-section .tabs__head");
      const resultNotFoundSelector = $(".result-not-found");
      const tabsBody = $("#tabs-body");
      let currentValue;
      let updatedData;
      searchContainer.hide();
      searchInput.on("input", function (event) {
        defaultAccordion.hide();
        searchContainerAccordion.empty();
        searchContainer.show();
        tabsBody.hide();
        currentValue = event.target.value;
        updatedData = fetchedData
          .filter((item, i) => {
            // console.log(item);
            if (currentValue !== "") {
              if (
                fetchedData[i].Question.toLowerCase().includes(
                  currentValue.toLowerCase()
                )
              ) {
                return fetchedData[i];
              }
              categoryTabs.hide();
            }
          })
          .map((item) => {
            return `<div class='accordion accordion--d-grey-bg' data-item-id='${item.Id}'>
								<span class="accordion__icon"></span> 
								<h4 class="accordion__heading">${item.Question}</h4>

								<div class="accordion__content">
									<p class="accordion__desc">${item.Answer}</p>
								</div>
					</div>`;
          });

        if (currentValue === "") {
          searchContainer.hide();
          updatedData = null;
          searchContainerAccordion.empty();
          tabsBody.show();
          defaultAccordion.show();
          defaultAccordion
            .find("#category-icon")
            .attr("src", "")
            .attr("alt", "");
          defaultAccordion.find("#category-search").text("");
          defaultAccordion.find("#accordianContainer").empty();
          categoryTabs.show();
        }
        searchContainerAccordion.append(updatedData);
        if (updatedData === null || updatedData.length === 0) {
          resultNotFoundSelector.removeClass("d-none");
        } else {
          resultNotFoundSelector.addClass("d-none");
        }
      });
    },

    _fetchedFAQData(data) {
      // console.log(data);

      const fetchedData = data;
      const tabsBody = $("#tabs-body");
      const categoriesIDArray = [];

      fetchedData.map((item) => {
        // console.log(item.CategoriesId);
        categoriesIDArray.push(item.CategoriesId[0]);
      });

      const sortedCategoriesID = categoriesIDArray.filter(
        (item, index) => categoriesIDArray.indexOf(item) === index
      );

      const generateTabPanes = sortedCategoriesID.map((item, index) => {
        // console.log(item);
        return `<div class='tabs__pane' data-category-id='${item}'>
							
				 </div>`;
      });
      tabsBody.append(generateTabPanes);

      fetchedData.map((item) => {
        // console.log(item);

        sortedCategoriesID.map((categoryItem, index) => {
          // debugger
          if (item.CategoriesId[0] === categoryItem) {
            // console.log('true');

            $(`[data-category-id="${categoryItem}"]`).append(
              `<div class='accordion accordion--d-grey-bg' data-cat-name='${item.CategoriesName}' data-cat-id='${item.CategoriesId}'>
								<span class="accordion__icon"></span> 
								<h4 class="accordion__heading">${item.Question}</h4>

								<div class="accordion__content">
									<p class="accordion__desc">${item.Answer}</p>
								</div>
				 			</div>`
            );
          }
        });

        /* return `<div class='accordion accordion--d-grey-bg ' data-item-id='${item.Id}'>
							<span class="accordion__icon"></span> 
							<h4 class="accordion__heading">${item.Question}</h4>

							<div class="accordion__content">
								<p class="accordion__desc">${item.Answer}</p>
							</div>
				 </div>` */
      });
    },

    faqSearch(data) {
      // console.log(data);

      if (data === "undefined" && data === null) return;
      app._fetchedFAQData(data);
      app._searchFAQData(data);
    },

    offers: function () {
      const listing = $("#offers-listing-list");
      let pageNumber = 1;

      if (listing.length !== 1) {
        return false;
      }

      if (app._qsToObject().category) {
        $("#offers-listing-cat").val(app._qsToObject().category);
      }
      if (app._qsToObject().card) {
        $("#offers-listing-type").val(app._qsToObject().card);
      }

      getItems(1);

      $("#offers-listing-cat").change(function () {
        const value = $(this).val();
        $("body").addClass("loading");

        if (value == 0) {
          app._removeUrlParameter("category");
        } else {
          app._setQueryParams("category", value);
        }
        pageNumber = 1;
        $("#offers-listing-list").empty();
        getItems(1);
      });
      $("#offers-listing-type").change(function () {
        const value = $(this).val();
        $("body").addClass("loading");
        if (value == 0) {
          app._removeUrlParameter("card");
        } else {
          app._setQueryParams("card", value);
        }

        pageNumber = 1;

        $("#offers-listing-list").empty();
        getItems(1);
      });

      $(".offers-listing-load").click(function (e) {
        e.preventDefault();
        pageNumber++;

        getItems(pageNumber);
      });

      function getItems(pageNumber) {
        let cat = app._qsToObject().category
          ? `&category=${app._qsToObject().category}`
          : "";
        let card = app._qsToObject().card
          ? `&card=${app._qsToObject().card}`
          : "";

        $("body").addClass("loading");

        const url = `${listing.attr("data-url")}?pageId=${$(
          "#OffersListParentID"
        ).val()}&all=false&pageNumber=${pageNumber}&pageSize=${listing.attr(
          "data-size"
        )}&culture=${app.culture}${cat}${card}`;
        //?pageId=ee466ce6-ef00-495c-8d7e-bf64ec85cd75&all=false&&category=dcd36e56-ef0d-4f40-8d27-8f9ff21306b2&card=0c13410c-73cd-42cd-bbe3-7ed306485087&pageNumber=1&pageSize=8&culture=en

        $.ajax({
          url,
          contentType: "application/json",
          dataType: "json",
        }).done(function (data) {
          console.log(
            pageNumber >= data.Result.TotalCount / listing.attr("data-size")
          );
          if (
            data.Result.TotalCount <= listing.attr("data-size") ||
            pageNumber >= data.Result.TotalCount / listing.attr("data-size")
          ) {
            $(".offers-listing-load").hide();
          } else {
            $(".offers-listing-load").show();
          }
          appendItems(data);
          $("body").removeClass("loading");
        });
      }

      function appendItems(data) {
        var markup = "";

        data.Result.OffersList.map((item) => {
          markup += `<div class="col-xl-5 col-lg-8">
                        <div class="card card--2 mt-0">
                          <div class="card__media"><a href="${item.Url}"> <img src="${item.ThumbnailImageUrl}" alt="${item.ThumbnailImageAlt}"></a></div>
                          <div class="card__copy">
                            <h3 class="card__title"> <a href="${item.Url}">${item.OfferName}</a></h3>
                            <p class="card__desc"><a href="${item.Url}">${item.OfferDescription}</a></p>
                          </div>
                        </div>
                      </div>
					`;
        });

        listing.append(markup);
      }
    },
    _qsToObject: function () {
      var pairs = window.location.search.substring(1).split("&"),
        obj = {},
        pair,
        i;

      for (i in pairs) {
        if (pairs[i] === "") continue;

        pair = pairs[i].split("=");
        obj[decodeURIComponent(pair[0])] = decodeURIComponent(
          pair[1].replaceAll("+", " ")
        );
      }

      return obj;
    },
    _setQueryParams: function (name, value) {
      if (history.pushState) {
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set(name, value);
        let newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?" +
          searchParams.toString();
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },

    _removeUrlParameter: function (paramKey) {
      const url = window.location.href;

      var r = new URL(url);
      r.searchParams.delete(paramKey);
      const newUrl = r.href;

      window.history.pushState({ path: newUrl }, "", newUrl);
    },
    productFinderApi: function () {
      $(".right-product__item").click(function () {
        $(".right-product__item").removeClass("active");
        $(this).addClass("active");

        $(".right-product__options").slideUp();
        $(".right-product").addClass("active");
        $(".right-product__options").eq($(this).parent().index()).slideDown();
      });

      const listing = $("#product-finder-list");
      let SuggesstionIds = [];
      let Suggesstions = [];
      $(".find-products").click(function () {
        $("body").addClass("loading");
        $("#product-finder-list").empty();

        $(".right-product__options:visible input:checked").each(function () {
          SuggesstionIds.push($(this).attr("data-id"));
          Suggesstions.push($(this).siblings("label").text());
        });
        console.log(SuggesstionIds);
        console.log(Suggesstions);
        var settings = {
          url: listing.attr("data-url"),
          method: "POST",
          timeout: 0,
          headers: {
            "Content-Type": "application/json",
            Cookie:
              "ASP.NET_SessionId=fm000tmjhjgnngzx53rhc0rp; SC_ANALYTICS_GLOBAL_COOKIE=94552166f8c147a68a2dca63136efd4d|False",
          },
          data: JSON.stringify({
            Language: app.culture,
            SuggesstionIds: SuggesstionIds,
          }),
        };

        $.ajax(settings).done(function (response) {
          $("body").removeClass("loading");
          appendItems(response);
          $("#product-finder-cont").removeClass("d-none");
          $("html, body").animate(
            {
              scrollTop: $("#product-finder-cont").offset().top,
            },
            0
          );

          $("#product-finder-item").text(
            $(".right-product__item.active p").html()
          );
          $("#product-finder-options").text(Suggesstions);
          SuggesstionIds = [];
          Suggesstions = [];
        });
      });
      function appendItems(data) {
        var markup = "";

        if (data.Result.ProductList.length === 0) {
          markup += `<h3 class='h4 text-center mt-50'>${listing.attr(
            "data-error"
          )}</h3>`;
        }

        data.Result.ProductList.map((item) => {
          markup += `<div class="col-xl-5 col-lg-8">
						<div class="card card--2 mt-0">
						  <div class="card__media"><a href="${item.Url}"> <img src="${item.ThumbnailImage}" alt="${item.ListingTitle}"></a></div>
						  <div class="card__copy">
							<h3 class="card__title"> <a href="${item.Url}">${item.ListingTitle}</a></h3>
							<p class="card__desc"><a href="${item.Url}">${item.ListingDescription}</a></p>
						  </div>
						</div>
					  </div>
					`;
        });

        listing.append(markup);
      }
    },

    formValidation: function () {
      var isFormValid = false;
      var isSearch = false;

      var alphaError = $("body").hasClass("ar")
        ? "لا يُسمح باستعمال أحرف خاصة"
        : "Special characters are not allowed";

      $(".eloqua-form").validate({
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        rules: {
          fullName: {
            required: true,
            alpha: true,
          },
          fullname1: {
            required: true,
            alpha: true,
          },

          firstName: {
            required: true,
            alpha: true,
          },

          lastName: {
            required: true,
            alpha: true,
          },

          emailAddress: {
            customEmail: true,
            required: true,
            maxlength: 64,
          },
          mobilePhone: {
            required: true,
            minlength: 13,
            maxlength: 13,
            phoneEnding6: true,
          },
          areyouanexistingcustomer1: {
            required: true,
          },
          generalEnquiry1: {
            required: true,
          },
          message1: {
            required: true,
          },

          areyouasalariedindividual1: {
            required: true,
          },
          whatisyourmonthlysalary1: {
            required: true,
          },
          nationality1: {
            required: true,
          },
          birthdate1: {
            required: true,
          },
          preferredtime1: {
            required: true,
          },
          minimummonthlyaccountbalance1: {
            required: true,
          },
          howlongwouldyoukeepyourmoneytomatur: {
            required: true,
          },
          numberofemployees1: {
            required: true,
          },
          company: {
            required: true,
          },
        },
        messages: {
          fullName: {
            alpha: alphaError,
          },

          firstName: {
            alpha: alphaError,
          },

          lastName: {
            alpha: alphaError,
          },
          fullname1: {
            alpha: alphaError,
          },
        },
        highlight: function (element) {
          $(element).parent().addClass("field-error");

          $(element).parents("fieldset").find("legend").addClass("field-error");
        },
        unhighlight: function (element) {
          $(element).parent().removeClass("field-error");
          $(element)
            .parents("fieldset")
            .find("legend")
            .removeClass("field-error");
        },
        submitHandler: function (form) {
          //	form.submit();
          //	alert('form is valid')
          isFormValid = true;
        },
      });
      $(".eloqua-form").on("submit", function (e) {
        e.preventDefault();
        //generateCaptchaToken()

        if (!isFormValid) {
          return false;
        } else {
          console.log("submit form");
          $(".eloqua-form").get(0).submit();
        }
      });

      $(".search__field").validate({
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        rules: {
          searchText: {
            required: true,
          },
        },

        highlight: function (element) {
          $(element).parent().addClass("field-error");

          $(element).parents("fieldset").find("legend").addClass("field-error");
        },
        unhighlight: function (element) {
          $(element).parent().removeClass("field-error");
          $(element)
            .parents("fieldset")
            .find("legend")
            .removeClass("field-error");
        },
        submitHandler: function (form) {
          //	form.submit();
          //	alert('form is valid')
          isSearch = true;
        },
      });
      $(".search__field").on("submit", function (e) {
        e.preventDefault();
        //generateCaptchaToken()

        if (!isSearch) {
          return false;
        } else {
          $(".search__field").get(0).submit();
        }
      });
    },

    _createCookie: function (cookieName, cookieValue, cookieDays) {
      var expires = "";
      if (cookieDays) {
        var date = new Date();
        date.setTime(date.getTime() + cookieDays * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toDateString();
      }
     
		document.cookie = cookieName + " = " + cookieValue + ";" + expires + "; path=/;secure;samesite=strict";
    },

    _getCookie: function (cookieName) {
      var cookieNameEQ = cookieName + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(cookieNameEQ) == 0)
          return c.substring(cookieNameEQ.length, c.length);
      }
      return null;
    },
    search: function () {
      $(".search__field input")
        .eq(1)
        .change(function () {
          $(".search__field input")
            .eq(0)
            .val($(".search__field input").eq(1).val());
        });

      if ($("#search-listing").length != 1 || !app._qsToObject().searchText) {
        return false;
      }

      console.log("searchinng");
      var markup = ``;
      var pageNumber = 1;

      // var url = "http://localhost:8080/http://cboj.iprox.net/api/search/globalsearch"
      var url = "/api/search/globalsearch";

      $("#search-heading")
        .removeClass("d-none")
        .text(app._qsToObject().searchText);

      $(".search__field input").val(app._qsToObject().searchText);

      getItems(1);

      $("#search-loadmore").click(function () {
        pageNumber++;

        markup = "";
        getItems(pageNumber);
      });

      function getItems(pageNumber) {
        $("body").addClass("loading");
        var settings = {
          url: url,
          method: "POST",
          timeout: 0,
          headers: {
            "Content-Type": "application/json",
          },
          data: JSON.stringify({
            Language: app.culture,
            Query: `${app._qsToObject().searchText}`,
            CurrentPage: pageNumber,
            SettingsId: `${$("#search-listing").attr("data-settingId")}`,
          }),
        };

        $.ajax(settings).done(function (response) {
          $("body").removeClass("loading");

          loadBranches(response.Results);

          if (response.Results.length === 0) {
            $("#search-listing-error").show();
          } else {
            $("#search-listing-error").hide();
          }

          if ($("#search-listing .row").length >= response.TotalCount) {
            $("#search-loadmore").hide();
          } else {
            $("#search-loadmore").show();
          }

          $(".search-listing__result").removeClass("d-none");
          $("#search-count").text(response.TotalCount + " ");
        });
      }

      function loadBranches(data = []) {
        for (let index = 0; index < data.length; index++) {
          markup += `<div class="row ${data[index].Title ? "" : "d-none"}"> 
					<div class="col-16">
					  <h2 class="h4 search-listing__desc">
					 	<a style='text-decoration:none' href=' ${data[index].Url}'>
						 ${data[index].Title || ""}
						</a> 
					  </h2>
					</div>
					<div class="col-xl-10 offset-xl-1 d-none">
					   
					  <p class="search-listing__desc">
					  <a href=' ${data[index].Url}'>
					  ${data[index].Description || "<br/><br/>"}
					 </a>  
					 
					 </p>
					</div>
				  </div>`;
        }

        $("#search-listing").append(markup);
      }
    },

    mediaListing: function (category, index) {
      var markup = "";

      const listing = $(".awards-listing").eq(index);
      const readMore = listing.attr("data-readmore");
      const pageSize = listing.attr("data-pagesize") || 15;
      let pageNumber = 1;

      if (listing.length !== 1) {
        return false;
      }

      getItems(1);

      var loadMoreBtn = listing
        .parents(".tabs__pane")
        .find(".award-listing-load");
      loadMoreBtn.click(function (e) {
        e.preventDefault();
        markup = "";
        pageNumber++;

        getItems(pageNumber);
      });

      function getItems(pageNumber) {
        $("body").addClass("loading");

        //const url = `${listing.attr('data-url')}?pageId=${$('#OffersListParentID').val()}&all=false&pageNumber=${pageNumber}&pageSize=${listing.attr('data-size')}&culture=${app.culture}${cat}${card}`;
        //?pageId=ee466ce6-ef00-495c-8d7e-bf64ec85cd75&all=false&&category=dcd36e56-ef0d-4f40-8d27-8f9ff21306b2&card=0c13410c-73cd-42cd-bbe3-7ed306485087&pageNumber=1&pageSize=8&culture=en
        var url = `/api/MediaCenterApi/Get?page=${pageNumber}&pageSize=${pageSize}${
          category === "0" ? "" : `&category=${category}`
        }`;

        if (window.location.hostname === "localhost") {
          url = `http://localhost:8080/http://cboj.iprox.net/api/MediaCenterApi/Get?page=${pageNumber}&pageSize=${pageSize}${
            category === "0" ? "" : `&category=${category}`
          }`;
        }

        var settings = {
          url: url,
          method: "GET",
          timeout: 0,
        };

        $.ajax(settings).done(function (response) {
          if (!response.loadMore) {
            loadMoreBtn.hide();
          } else {
            loadMoreBtn.show();
          }
          appendItems(response);
          $("body").removeClass("loading");
        });
      }

      function appendItems(data) {
        data.Result.MediaCenterList.map((item) => {
          markup += `<div class="awards__item">
			<div class="awards__media">
			  <div class="awards__img-wrapper"><img class=" awards__img "  src="${item.ThumbnailImageUrl}" alt="${item.Title}">
			  </div>
			</div>
			<div class="awards__content">
			  <div class="awards__date">${item.Date}</div>
			  <h3 class="h3 awards__heading">${item.Title}</h3>
			  <p class="awards__desc">${item.Description}</p>
			  <div class="awards__footer"><a class="btn btn--border-blue awards__btn" href="${item.NewsUrl}" title="${readMore}">${readMore}</a>
				 
			  </div>
			</div>
		  </div>`;
        });

        listing.append(markup);
      }
    },
    creditCardScroll: function (index) {
      const slider = document.querySelectorAll(
        ".lifestyle__swiper-slider .scroll-h"
      )[index];

      if (slider === undefined) {
        return false;
      }

      let mouseDown = false;
      let startX, scrollLeft;

      let startDragging = function (e) {
        mouseDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      };
      let stopDragging = function (event) {
        mouseDown = false;
      };

      slider.addEventListener("mousemove", (e) => {
        e.preventDefault();
        if (!mouseDown) {
          return;
        }
        const x = e.pageX - slider.offsetLeft;
        const scroll = x - startX;
        slider.scrollLeft = scrollLeft - scroll;
      });

      // Add the event listeners
      slider.addEventListener("mousedown", startDragging, true);
      slider.addEventListener("mouseup", stopDragging, false);
      slider.addEventListener("mouseleave", stopDragging, false);
    },

    getMobileOperatingSystem: function () {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
        return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }

      return "unknown";
    },

    smartBanner: function () {
      if (app._getCookie("smartbannerClose")) {
        return false;
      }

      if (app.getMobileOperatingSystem() === "Android") {
        $(".smartbanner").show();
        $("body").addClass("smartbanner-visible");
      }

      $(".smartbanner__close ,.smartbanner .btn").click(function () {
        $(".smartbanner").hide();

        app._createCookie("smartbannerClose", true, 360);
        $("body").removeClass("smartbanner-visible");
      });
    },

    jobSearch: function () {
      $("#job-filters-Categories").val(app._qsToObject().Categories);
      $("#job-filters-Locations").val(app._qsToObject().Locations);
      $("#job-filters-Professions").val(app._qsToObject().Professions);
      $("#job-filters-search").val(app._qsToObject().Query);

      const applyNow = $("#job-filters").attr("data-apply");

      $("#job-filters-btn").click(function () {
        app._removeUrlParameter("Categories");
        app._removeUrlParameter("Locations");
        app._removeUrlParameter("Professions");
        app._removeUrlParameter("Query");

        // $('#job-filters select').each(function(){

        // 	if($(this).val() !== ""){

        // 		$(this).attr('data-filter')

        // 	}
        // })
        if ($("#job-filters-Categories").val())
          app._setQueryParams("Categories", [
            $("#job-filters-Categories").val() || "",
          ]);
        if ($("#job-filters-Locations").val())
          app._setQueryParams("Locations", [
            $("#job-filters-Locations").val() || "",
          ]);
        if ($("#job-filters-Professions").val())
          app._setQueryParams("Professions", [
            $("#job-filters-Professions").val() || "",
          ]);
        if ($("#job-filters-search").val())
          app._setQueryParams("Query", $("#job-filters-search").val());

        window.location = $(this).attr("data-url") + window.location.search;
        // console.log(wind)
      });

      if ($("#job-listing").length !== 1) {
        return false;
      }

      var url = `/api/jobs/search`;

      if (window.location.hostname === "localhost") {
        url = `http://localhost:8080/https://cboj-internal.iprox.net/api/jobs/search`;
      }

      let obj = {};

      if ($("#job-filters-Categories").val())
        obj = { ...obj, Categories: [app._qsToObject().Categories] };
      if ($("#job-filters-Locations").val())
        obj = { ...obj, Locations: [app._qsToObject().Locations] };
      if ($("#job-filters-Professions").val())
        obj = { ...obj, Professions: [app._qsToObject().Professions] };
      if ($("#job-filters-search").val())
        obj = { ...obj, Query: app._qsToObject().Query };

      var settings = {
        url: url,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
          Cookie:
            "ASP.NET_SessionId=i3rs5i4rg2wjmkvvvnayy20i; SC_ANALYTICS_GLOBAL_COOKIE=75fa8a0af62547e6b3072124ebb3f867|False",
        },
        data: JSON.stringify({
          Language: app.culture,
          CurrentPage: 1,
          ...obj,
          SettingsId: $("#job-filters").attr("data-settings"),
        }),
      };

      $("body").addClass("loading");

      console.log("settings", settings);
      $.ajax(settings).done(function (response) {
        $("body").removeClass("loading");
        if (response.results.length === 0) {
          $("#job-error").show();
        } else {
          $("#job-error").hide();

          appendItems(response);
        }
      });

      function appendItems(data) {
        var markup = "";

        data.results.map((item) => {
          markup += `<div class="jobs__item">
						<div class="jobs__date">${item.publishDate}</div>
					<h3 class="h3 jobs__heading">${item.title}</h3>
					<div class="jobs__location-wrapper">
							<div class="jobs__ref ${item.reference ? "" : "d-none"}">
								<svg id="Group_15152" data-name="Group 15152" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16.222" height="21.947" viewBox="0 0 16.222 21.947">
									<defs>
										<clipPath>
											<rect data-name="Rectangle 6049" width="16.222" height="21.947" fill="#0095c8" stroke="#0095c8" stroke-width="0.5"></rect>
										</clipPath>
									</defs>
									<g data-name="Group 15151">
										<path data-name="Path 12658" d="M15.8,5.586,10.636.419a1.448,1.448,0,0,0-.2-.163A.476.476,0,0,0,10.019,0a.465.465,0,0,0-.141.024A1.445,1.445,0,0,0,9.624,0H1.431A1.433,1.433,0,0,0,0,1.432V20.516a1.433,1.433,0,0,0,1.431,1.431H14.79a1.433,1.433,0,0,0,1.432-1.431V6.6a1.421,1.421,0,0,0-.42-1.012m-.535,14.93a.478.478,0,0,1-.477.477H1.431a.478.478,0,0,1-.477-.477V1.432A.477.477,0,0,1,1.431.954H9.542V6.2a.477.477,0,0,0,.477.477h2.863a.477.477,0,1,0,0-.954H10.5v-4.1L15.128,6.26a.474.474,0,0,1,.14.337Z" fill="#0095c8" stroke="#0095c8" stroke-width="0.5"></path>
									</g>
								</svg>${item.reference}
							</div>
																							<div class="jobs__location  ${item.locations.length === 0 ? "d-none" : ""}"">
								<svg xmlns="http://www.w3.org/2000/svg" width="17.08" height="24.393" viewBox="0 0 17.08 24.393">
									<g id="Group_15153" data-name="Group 15153" transform="translate(0.25 0.25)">
										<path id="Path_12656" data-name="Path 12656" d="M16.579,8.281A8.288,8.288,0,0,0,0,8.278c-.108,4.756,4.049,10.354,6.532,13.7.461.621.86,1.157,1.177,1.613a.705.705,0,0,0,1.158,0c.318-.458.717-.993,1.177-1.614,2.483-3.344,6.639-8.94,6.533-13.7M9.264,21.4c-.365.492-.692.932-.974,1.326-.281-.393-.608-.832-.974-1.326C4.907,18.15.873,12.717.975,8.295V8.283a7.314,7.314,0,0,1,14.628,0V8.3c.1,4.423-3.931,9.854-6.341,13.1" transform="translate(0)" fill="#0095c8" stroke="#0095c8" stroke-width="0.5"></path>
										<path id="Path_12657" data-name="Path 12657" d="M7.73,2.633a4.944,4.944,0,1,0,4.944,4.944A4.95,4.95,0,0,0,7.73,2.633m0,8.914a3.97,3.97,0,1,1,3.97-3.97,3.975,3.975,0,0,1-3.97,3.97" transform="translate(0.56 0.529)" fill="#0095c8" stroke="#0095c8" stroke-width="0.5"></path>
									</g>
								</svg>

								<text>${item.locations.toString()}</text>

							</div>
					</div>
					<p class="jobs__desc">${item.description}</p>
					<a class="btn btn--border-blue jobs__btn" href="${
            item.url
          }" title="${applyNow}">${applyNow}</a>
				</div>
					`;
        });

        $("#job-listing").append(markup);
      }
    },

    _setQueryParams: function (name, value) {
      if (history.pushState) {
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set(name, value);
        let newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?" +
          searchParams.toString();
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    _qsToObject: function () {
      var pairs = window.location.search.substring(1).split("&"),
        obj = {},
        pair,
        i;

      for (i in pairs) {
        if (pairs[i] === "") continue;

        pair = pairs[i].split("=");
        obj[decodeURIComponent(pair[0])] = decodeURIComponent(
          pair[1].replaceAll("+", " ")
        );
      }

      return obj;
    },
    _removeUrlParameter: function (paramKey) {
      const url = window.location.href;

      var r = new URL(url);
      r.searchParams.delete(paramKey);
      const newUrl = r.href;

      window.history.pushState({ path: newUrl }, "", newUrl);
    },
    _cookiesPopup: function () {
      $(".cookies-overlay__close,#acceptAll,#rejectAll").on(
        "click",
        function () {
          $(".cookies-overlay").removeClass("show");
          app._createCookie("popupCookies", true, 360);
        }
      );

      if (app._getCookie("popupCookies") === "true") {
        $(".cookies-overlay").removeClass("show");
      } else {
        $(".cookies-overlay").addClass("show");
      }
    },

    init() {
      app.detectCulture();

      app.detectDevice();
      app.resizeListner();
      app.addEventListner();
      app.lazyLoad();
      app.swiper();
      app.productFinder();
      app.bankServices();
      app.tabs();
      app.rangeSlider();
      app.customSelect();
      app.lifestyleAnimation();
      app.accordion();
      app.roundSlier();
      app.random();
      app.googleMap();
      app.imageVideo();
      app.iban();
      app.gridSlideAnimation();
      // app.faqSearch();
      app.offers();
      app.productFinderApi();
      app.formValidation();
      app.search();
      app.mediaListing("0", 0);

      $("#news-tabs li").click(function () {
        console.log($(this).attr("data-category"));
        app.mediaListing($(this).attr("data-category"), $(this).index());
      });

      app.creditCardScroll(0);
      app.creditCardScroll(1);
      app.creditCardScroll(2);
      app.smartBanner();
      app.copyToClipBoard();
      app.jobSearch();
      app._cookiesPopup();
    },
  };
  window.app = app;
})(jQuery);

$(document).ready(() => {
  window.app.init();
});

function actionIbanForm(account_number, branch_code) {
  var iban = '';
  account_number = '4' + account_number.trim();

  if (account_number.length !== 7) {
    return false;
  }

  var output = '';
  var number_format = "14151120" + branch_code + "00000000000" + account_number + "192400";
  output += number_format + " - ";
  var first_mod = String(number_format.substr(0, 9) % 97);
  var first_mod_removed = number_format.substr(9);
  var checkdigit1 = first_mod + first_mod_removed;
  output += checkdigit1 + " - ";
  first_mod = checkdigit1.substr(0, 9) % 97;
  first_mod_removed = checkdigit1.substr(9);
  checkdigit1 = first_mod + first_mod_removed;
  output += checkdigit1 + '-';
  first_mod = checkdigit1.substr(0, 9) % 97;
  first_mod_removed = checkdigit1.substr(9);
  checkdigit1 = first_mod + first_mod_removed;
  output += checkdigit1+ " - ";
  first_mod = checkdigit1.substr(0, 9) % 97;
  first_mod_removed = checkdigit1.substr(9);
  checkdigit1 = first_mod + first_mod_removed;
  output += checkdigit1+ " - ";
  checkdigit1 = checkdigit1 % 97;
  output += checkdigit1+ " - ";
  var checkdigit_final = 98 - checkdigit1;
  output += checkdigit_final+ " - ";
  var pad_left = '';

  if (String(checkdigit_final).length > 1) {
	pad_left = String(checkdigit_final).substr(0, 2);
  } else {
	pad_left = '0' + checkdigit_final;
  }

  iban = 'JO' + pad_left + 'EFBK' + branch_code + '00000000000' + account_number;
  return iban;
}

$.validator.addMethod("alpha", function (value, element) {
	
	return this.optional(element) || /^[a-zA-z][a-zA-Z ]*$|^[\u0600-\u06FF][\u0600-\u06FF ]*$/i.test(value);
});

var emailError = $("body").hasClass("ar")
  ? "الرجاء إدخال عنوان بريد إلكتروني صالح! "
  : "Please enter valid email address!";
var phoneErro = $("body").hasClass("ar")
  ? "يجب أن يبدأ رقم الهاتف بـ 962+"
  : "Phone number should start with +962";

jQuery.validator.addMethod(
  "customEmail",
  function (value, element) {
    return (
      this.optional(element) ||
      /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i.test(
        value
      )
    );
  },
  emailError
);

jQuery.validator.addMethod(
  "phoneEnding6",
  function (phone_number, element) {
    phone_number = phone_number.replace(/\s+/g, "");

    console.log(phone_number.substring(0, 4) === "+962");

    ///(/^(?:\+971)$/m)
    return this.optional(element) || phone_number.substring(0, 4) === "+962";
  },
  phoneErro
);
